import React, { useState } from "react";
import "./Sponsors.css";
import { sponsors, tierOrder } from "../data/sponsors";

const groupedSponsors = sponsors.reduce((acc, sponsor) => {
  if (!acc[sponsor.tier]) acc[sponsor.tier] = [];
  acc[sponsor.tier].push(sponsor);
  return acc;
}, {});

const SponsorLogo = ({ sponsor }) => {
  if (sponsor.src) {
    return (
      <a
        href={sponsor.link || undefined}
        target={sponsor.link ? "_blank" : undefined}
        rel="noopener noreferrer"
        className="sponsor-link"
      >
        <img
          src={sponsor.src}
          alt={sponsor.name}
          className="sponsor-logo"
          loading="lazy"
        />
      </a>
    );
  }

  return (
    <div className="sponsor-text-only">
      {sponsor.link ? (
        <a
          href={sponsor.link}
          target="_blank"
          rel="noopener noreferrer"
          className="sponsor-text-link"
        >
          {sponsor.name}
        </a>
      ) : (
        <span className="sponsor-text-name">{sponsor.name}</span>
      )}
    </div>
  );
};

const Sponsors = () => {
  // On touch screens the description opens inline when the sponsor name is tapped;
  // on desktop it shows as a tooltip on hover/focus (handled in CSS).
  const [expandedSponsor, setExpandedSponsor] = useState(null);

  return (
    <section className="section sponsors-section">
      <div className="sponsors-content">
        <h2 className="section-title">Our Sponsors</h2>
        {tierOrder.map((tierName) => {
          const tierSponsors = groupedSponsors[tierName] || [];
          if (tierSponsors.length === 0) return null;

          return (
            <div key={tierName} className="sponsor-tier-section">
              <h3 className="tier-title">{tierName}s</h3>
              <div className="sponsor-logos">
                {tierSponsors.map((sponsor) => {
                  const isExpanded = expandedSponsor === sponsor.name;
                  const tooltipId = `sponsor-info-${sponsors.indexOf(sponsor)}`;
                  return (
                    <div
                      key={sponsor.name}
                      className={`sponsor-container ${
                        isExpanded ? "expanded" : ""
                      }`}
                    >
                      <SponsorLogo sponsor={sponsor} />
                      {sponsor.description ? (
                        <button
                          type="button"
                          className="sponsor-name"
                          aria-expanded={isExpanded}
                          aria-controls={tooltipId}
                          onClick={() =>
                            setExpandedSponsor(isExpanded ? null : sponsor.name)
                          }
                        >
                          {sponsor.name}
                          <span className="sponsor-info-icon" aria-hidden="true">
                            {isExpanded ? "−" : "+"}
                          </span>
                        </button>
                      ) : (
                        <div className="sponsor-name">{sponsor.name}</div>
                      )}
                      {sponsor.description && (
                        <div
                          id={tooltipId}
                          className="sponsor-tooltip"
                          role="tooltip"
                        >
                          <div className="tooltip-content">
                            {sponsor.description
                              .split("\n")
                              .map((line, lineIndex) => (
                                <div key={lineIndex} className="tooltip-line">
                                  {line}
                                </div>
                              ))}
                          </div>
                          <div className="tooltip-arrow"></div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Sponsors;
